import { borderRadius, colors, padding } from "./stylesConstants";

export const theme = {
  colors: colors,
  padding: padding,
  borderRadius: borderRadius,
};
